import React from "react";
import { formatPropertyIdentifier } from "../../components/helpers/propertyIdentifier";

/**
 * A mobile property card showing cadastral info, project, and units.
 */
export default function MobilePropertyItem({ property, onClick }) {
  return (
    <div className="mobile-property-item" onClick={onClick}>
      <div className="mobile-property-item__header">
        <span className="mobile-property-item__cadastral">
          Cadastral: {formatPropertyIdentifier(property.cadastral_nr, property.partition_nr) || "N/A"}
        </span>
      </div>
      {property.project && (
        <div className="mobile-property-item__project">
          {property.project.project_placeholder_name || property.project.project_commercial_name}
        </div>
      )}
      {property.units && property.units.length > 0 && (
        <div className="mobile-property-item__units">
          {property.units.map((unit, idx) => (
            <span key={idx} className="mobile-unit-tag">{unit.unit_name}</span>
          ))}
        </div>
      )}
    </div>
  );
}

